import { CommonModule, NgFor, NgIf } from '@angular/common'
import { Component, inject, OnDestroy } from '@angular/core'
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms'
import { HasPermissionDirective } from '../../../../directives/has-permission.directive'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { Store } from '@ngrx/store'
import { filter, Subject, takeUntil, tap } from 'rxjs'
import { taxSettingsActions } from '../../../../store/tax-settings/tax-settings.actions'
import {
  selectFinancialYears,
  selectFyTaxSettings
} from '../../../../store/tax-settings/tax-settings.reducers'
import { TaxSlab } from '../../../../store/tax-settings/tax-settings.state'

@Component({
  selector: 'app-tax-slabs',
  imports: [NgFor, NgIf, FormsModule, ReactiveFormsModule, CommonModule, HasPermissionDirective],
  templateUrl: './tax-slabs.component.html',
  styleUrl: './tax-slabs.component.scss'
})
export class TaxSlabsComponent implements OnDestroy {
  private modalService = inject(NgbModal)
  private fb = inject(FormBuilder)
  private store = inject(Store)
  private destroy$ = new Subject<void>()

  //States
  form!: FormGroup
  operation = 'Add'
  financialYears$ = this.store.select(selectFinancialYears)
  selectedFinancialYear = new FormControl('', { nonNullable: true })
  taxSettings$ = this.store.select(selectFyTaxSettings)
  itemId = ''

  constructor() {
    this.store.dispatch(taxSettingsActions.loadFinancialYears())
    this.initializeForm()
    this.selectedFinancialYear.valueChanges
      .pipe(
        takeUntil(this.destroy$),
        filter(yearId => !!yearId),
        tap(endYear => {
          console.log('y', endYear)
          this.store.dispatch(
            taxSettingsActions.loadSlabsAndRules({
              date: new Date(endYear)
            })
          )
        })
      )
      .subscribe()
    //this.store.dispatch(loadSalaryComponents({ componentType: STANDARD_EARNINGS, belongsTo: null }))
    this.financialYears$.subscribe(v => console.log('v', v))
  }

  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }

  initializeForm() {
    this.form = this.fb.group({
      financialYearId: [null, Validators.required],
      regime: [{ value: 'New', disabled: true }, Validators.required],
      lowerLimit: [0, Validators.required],
      upperLimit: [null],
      ratePercent: [0, Validators.required]
    })
  }

  sendData() {
    console.log('sendData', this.form.getRawValue())
    //switch (this.operation) {
    //  case 'Add':
    //    this.store.dispatch(addSalaryComponent({ salaryComponent: this.form.value }))
    //    break
    //  case 'Edit':
    //    this.store.dispatch(
    //      editSalaryComponent({ id: this.itemId, salaryComponent: this.form.value })
    //    )
    //    break
    //  case 'Delete':
    //    this.store.dispatch(
    //      deleteSalaryComponent({ id: this.itemId, componentType: STANDARD_EARNINGS })
    //    )
    //    break
    //  default:
    //    break
    //}
    this.onClose()
  }

  getErrorMessage(controlName: string): string | null {
    const control = this.form.get(controlName)
    // console.log('control name', control)
    if (control && control.touched && control.invalid) {
      if (control.hasError('required')) {
        return 'This field is required'
      }
    }
    return null // No error
  }

  openModel(modal: unknown) {
    this.operation = 'Add'
    this.itemId = ''
    this.modalService.open(modal, {
      scrollable: false,
      centered: true,
      size: 'md'
    })
  }

  openEditModal(modal: unknown, itemData: TaxSlab) {
    this.operation = 'Edit'
    this.itemId = itemData.id
    this.form.get('financialYearId')?.setValue(itemData.financialYear.id)
    this.form.get('regime')?.setValue(itemData.regime)
    this.form.get('lowerLimit')?.setValue(itemData.lowerLimit)
    this.form.get('upperLimit')?.setValue(itemData.upperLimit)
    this.form.get('ratePercent')?.setValue(itemData.ratePercent)

    this.modalService.open(modal, {
      scrollable: false,
      centered: true,
      size: 'md'
    })
  }

  openDeleteModal(modal: unknown, itemData: TaxSlab) {
    this.operation = 'Delete'
    this.itemId = itemData.id
    this.modalService.open(modal, {
      scrollable: false,
      centered: true,
      size: 'md'
    })
  }

  onClose() {
    this.modalService.dismissAll()
    this.form.reset()
    this.initializeForm()
  }
}
